import { render, staticRenderFns } from "./StopsOverview.vue?vue&type=template&id=35f37358&"
import script from "./StopsOverview.vue?vue&type=script&lang=js&"
export * from "./StopsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35f37358')) {
      api.createRecord('35f37358', component.options)
    } else {
      api.reload('35f37358', component.options)
    }
    module.hot.accept("./StopsOverview.vue?vue&type=template&id=35f37358&", function () {
      api.rerender('35f37358', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Stops/StopsOverview.vue"
export default component.exports